export var ModalType;

(function (ModalType) {
  ModalType["SENDPOST"] = "Send post";
  ModalType["SENDTESTEMAIL"] = "Send Test Email";
  ModalType["POSTSENT"] = "Post sent";
  ModalType["DELETE"] = "Delete";
  ModalType["PUBLISH"] = "Publish";
})(ModalType || (ModalType = {}));